import React from 'react';

const statItems = [
  { key: 'total', label: 'Wszystkie:', color: 'var(--primary)' },
  { key: 'pending', label: 'Oczekujące:', color: 'var(--warning)' },
  { key: 'completed', label: 'Zatwierdzone:', color: 'var(--success)' },
  { key: 'added', label: 'Dodane (PZ):', color: '#2e7d32' },
  { key: 'month', label: 'Ten miesiąc:', color: 'var(--info)' },
];

const PurchaseInvoiceStats = ({ stats }) => {
  if (!stats) return null;

  const invoices = stats.invoices || {};

  return (
    <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.75rem', flexWrap: 'wrap' }}>
      {statItems.map(({ key, label, color }) => (
        <div key={key} style={{
          backgroundColor: 'var(--card-bg)', padding: '0.4rem 0.6rem', borderRadius: '4px',
          boxShadow: '0 1px 2px rgba(0,0,0,0.08)', borderLeft: `3px solid ${color}`,
          display: 'flex', alignItems: 'center', gap: '0.5rem'
        }}>
          <span style={{ fontSize: '9px', color: 'var(--text-muted)' }}>{label}</span>
          <span style={{ fontSize: '14px', fontWeight: '700', color }}>{invoices[key] || 0}</span>
        </div>
      ))}
    </div>
  );
};

export default PurchaseInvoiceStats;
